import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer position-relative overflow-hidden">
      {/* Decorative Elements */}
      <div className="position-absolute top-0 start-0 w-100" style={{
        height: '4px',
        background: 'linear-gradient(90deg, #B59A5A, #D4B573, #B59A5A)',
        zIndex: 2
      }}></div>

      {/* Background Pattern */}
      <div className="position-absolute top-0 start-0 w-100 h-100" style={{
        backgroundImage: 'radial-gradient(rgba(255, 255, 255, 0.05) 1px, transparent 1px)',
        backgroundSize: '50px 50px',
        zIndex: 1,
        opacity: 0.3
      }}></div>

      <Container className="position-relative" style={{ zIndex: 3 }}>
        {/* Main Footer Content */}
        <Row className="pb-5 mb-5">
          <Col lg={4} className="mb-5 mb-lg-0">
            {/* Brand Section */}
            <div className="mb-4">
              <Link to="/" className="d-inline-block">
                <img
                  src="/images/golf-logo.png"
                  alt="Golf4International Logo"
                  style={{
                    height: '60px',
                    width: 'auto',
                    maxWidth: '220px',
                    //    filter: 'brightness(0) invert(1)'
                  }}
                />
              </Link>
            </div>

            <p className="mb-4" style={{
              opacity: 0.8,
              lineHeight: '1.8',
              fontSize: '0.95rem',
              maxWidth: '400px'
            }}>
              Redefining golf accessibility through innovation, technology, and premium experiences.
              We're committed to making world-class golf accessible to enthusiasts worldwide.
            </p>

            {/* Social Links */}
            {/* Social Links */}
            <div className="d-flex gap-3 mb-4">

              <a
                href="https://www.facebook.com/profile.php?id=61583824784286"
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon d-flex align-items-center justify-content-center"
                style={{
                  width: '40px',
                  height: '40px',
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  borderRadius: '50%',
                  color: 'white',
                  textDecoration: 'none',
                  transition: 'all 0.3s ease'
                }}
              >
                <i className="fab fa-facebook-f"></i>
              </a>

              <a
                href="https://www.instagram.com/golf.internationalpvt/"
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon d-flex align-items-center justify-content-center"
                style={{
                  width: '40px',
                  height: '40px',
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  borderRadius: '50%',
                  color: 'white',
                  textDecoration: 'none',
                  transition: 'all 0.3s ease'
                }}
              >
                <i className="fab fa-instagram"></i>
              </a>

              <a
                href="https://www.linkedin.com/in/golf4-international-7ba618397/"
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon d-flex align-items-center justify-content-center"
                style={{
                  width: '40px',
                  height: '40px',
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  borderRadius: '50%',
                  color: 'white',
                  textDecoration: 'none',
                  transition: 'all 0.3s ease'
                }}
              >
                <i className="fab fa-linkedin-in"></i>
              </a>

            </div>

            {/* Newsletter Signup */}
            <div className="newsletter-signup">
              <p className="small mb-2" style={{ opacity: 0.9 }}>Stay updated with golf insights</p>
              <div className="d-flex">
                <input
                  type="email"
                  placeholder="Your email address"
                  className="flex-grow-1"
                  style={{
                    padding: '10px 15px',
                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                    border: '1px solid rgba(255, 255, 255, 0.2)',
                    color: 'white',
                    borderRadius: '4px 0 0 4px',
                    borderRight: 'none',
                    fontSize: '0.9rem'
                  }}
                />
                <button
                  className="newsletter-btn"
                  style={{
                    padding: '10px 20px',
                    backgroundColor: 'var(--muted-gold)',
                    color: 'white',
                    border: 'none',
                    borderRadius: '0 4px 4px 0',
                    fontWeight: '600',
                    fontSize: '0.9rem',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease'
                  }}
                >
                  →
                </button>
              </div>
            </div>
          </Col>

          {/* Quick Links */}
          <Col lg={2} md={4} className="mb-5 mb-md-0">
            <div className="mb-4 position-relative">
              <h5 className="h6 mb-3 fw-bold text-uppercase letter-spacing-1">Quick Links</h5>
              <div style={{
                width: '30px',
                height: '2px',
                backgroundColor: 'var(--muted-gold)',
                marginBottom: '20px'
              }}></div>
            </div>
            <ul className="list-unstyled footer-links">
              {[
                { path: '/', label: 'Home' },
                { path: '/services', label: 'Services' },
                { path: '/tournament', label: 'Tournament' },
                { path: '/academy', label: 'Academy' },
                { path: '/about', label: 'About Us' },
                { path: '/blog', label: 'Blog' },
                { path: '/contact', label: 'Contact' }
              ].map((link, index) => (
                <li key={index} className="mb-2">
                  <Link
                    to={link.path}
                    className="footer-link d-inline-block py-1"
                    style={{
                      color: 'rgba(255, 255, 255, 0.8)',
                      textDecoration: 'none',
                      transition: 'all 0.3s ease',
                      position: 'relative',
                      paddingLeft: '0'
                    }}
                  >
                    <span className="me-2" style={{ opacity: 0.5 }}>›</span>
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </Col>

          {/* Services */}
          <Col lg={3} md={4} className="mb-5 mb-md-0">
            <div className="mb-4 position-relative">
              <h5 className="h6 mb-3 fw-bold text-uppercase letter-spacing-1">Our Services</h5>
              <div style={{
                width: '30px',
                height: '2px',
                backgroundColor: 'var(--muted-gold)',
                marginBottom: '20px'
              }}></div>
            </div>
            <ul className="list-unstyled footer-services">
              {[
                { icon: '🏌️', label: 'Golf Academy', desc: 'Professional Coaching' },
                { icon: '📊', label: 'Golf Simulators', desc: 'Advanced Technology' },
                { icon: '🛒', label: 'Pro Shop', desc: 'Premium Equipment' },
                { icon: '⚙️', label: 'Custom Fitting', desc: 'Personalized Gear' },
                { icon: '🏆', label: 'Tournaments', desc: 'Competitive Events' },
                { icon: '👨‍👩‍👧‍👦', label: 'Family Programs', desc: 'For All Ages' }
              ].map((service, index) => (
                <li key={index} className="mb-3">
                  <div className="d-flex align-items-center">
                    <div className="me-3" style={{
                      width: '36px',
                      height: '36px',
                      backgroundColor: 'rgba(181, 154, 90, 0.2)',
                      borderRadius: '8px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '1rem'
                    }}>
                      {service.icon}
                    </div>
                    <div>
                      <div className="small fw-medium" style={{ color: 'white' }}>{service.label}</div>
                      <div className="extra-small" style={{ color: 'rgba(255, 255, 255, 0.6)', fontSize: '0.8rem' }}>
                        {service.desc}
                      </div>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </Col>

          {/* Contact Info */}
          <Col lg={3} md={4}>
            <div className="mb-4 position-relative">
              <h5 className="h6 mb-3 fw-bold text-uppercase letter-spacing-1">Contact Us</h5>
              <div style={{
                width: '30px',
                height: '2px',
                backgroundColor: 'var(--muted-gold)',
                marginBottom: '20px'
              }}></div>
            </div>
            <ul className="list-unstyled contact-info">
              {[
                {
                  icon: 'fas fa-map-marker-alt',
                  content: '353/1, Ground Floor, Holy Chowk, Near UCO Bank, Bijwasan, New Delhi, PIN : 110061',
                  link: 'https://maps.google.com'
                },
                {
                  icon: 'fas fa-phone',
                  content: '011 - 45589523',
                  link: 'tel:+918610788265'
                },
                {
                  icon: 'fas fa-envelope',
                  content: 'cmd@heimdall.org.in',
                  link: 'mailto:cmd@heimdall.org.in'
                },
                {
                  icon: 'fas fa-globe',
                  content: 'www.sifgroup.org',
                  link: 'https://sifgroup.org/'
                },
                {
                  icon: 'far fa-clock',
                  content: 'Mon-Sun: 6:00 AM - 10:00 PM',
                  link: null
                }
              ].map((contact, index) => (
                <li key={index} className="mb-3">
                  <div className="d-flex">
                    <div className="me-3" style={{
                      width: '36px',
                      height: '36px',
                      backgroundColor: 'rgba(255, 255, 255, 0.1)',
                      borderRadius: '8px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexShrink: 0
                    }}>
                      <i className={contact.icon} style={{ color: 'var(--muted-gold)', fontSize: '0.9rem' }}></i>
                    </div>
                    <div style={{ lineHeight: '1.5' }}>
                      {contact.link ? (
                        <a
                          href={contact.link}
                          target={contact.link.startsWith('http') ? '_blank' : '_self'}
                          rel="noopener noreferrer"
                          className="contact-link"
                          style={{
                            color: 'rgba(255, 255, 255, 0.9)',
                            textDecoration: 'none',
                            transition: 'all 0.3s ease',
                            fontSize: '0.9rem'
                          }}
                        >
                          {contact.content}
                        </a>
                      ) : (
                        <span style={{ color: 'rgba(255, 255, 255, 0.9)', fontSize: '0.9rem' }}>
                          {contact.content}
                        </span>
                      )}
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </Col>
        </Row>

        {/* Divider */}
        <div style={{
          height: '1px',
          backgroundColor: 'rgba(255, 255, 255, 0.1)',
          marginBottom: '40px'
        }}></div>

        {/* Bottom Bar */}
        <Row className="align-items-center">
          <Col md={6} className="mb-3 mb-md-0">
            <div className="d-flex flex-wrap align-items-center gap-3">
              <span className="extra-small" style={{ color: 'rgba(255, 255, 255, 0.7)' }}>
                © {currentYear} Golf4International Private Limited. All rights reserved.
              </span>

              {/* Legal Links */}
              <div className="d-flex gap-3">
                {['Privacy Policy', 'Terms of Service', 'Cookie Policy'].map((item, index) => (
                  <a
                    key={index}
                    href={`/${item.toLowerCase().replace(/\s+/g, '-')}`}
                    className="legal-link extra-small"
                    style={{
                      color: 'rgba(255, 255, 255, 0.7)',
                      textDecoration: 'none',
                      transition: 'all 0.3s ease'
                    }}
                  >
                    {item}
                  </a>
                ))}
              </div>
            </div>
          </Col>

          <Col md={6} className="text-md-end">
            <div className="d-flex align-items-center justify-content-md-end gap-3">
              <span className="extra-small" style={{ color: 'rgba(255, 255, 255, 0.7)' }}>
                Crafted with precision for the modern golfer
              </span>
              <div style={{
                width: '4px',
                height: '4px',
                backgroundColor: 'var(--muted-gold)',
                borderRadius: '50%'
              }}></div>
              <span className="extra-small" style={{ color: 'rgba(255, 255, 255, 0.7)' }}>
                ISO 9001:2015 Certified
              </span>
            </div>
          </Col>
        </Row>
      </Container>

      {/* Add hover effects CSS */}
      <style jsx>{`
        .social-icon:hover {
          background-color: var(--muted-gold) !important;
          transform: translateY(-2px);
        }
        
        .footer-link:hover {
          color: var(--muted-gold) !important;
          padding-left: 8px !important;
        }
        
        .footer-link:hover span {
          opacity: 1 !important;
          color: var(--muted-gold) !important;
        }
        
        .contact-link:hover {
          color: var(--muted-gold) !important;
        }
        
        .legal-link:hover {
          color: var(--muted-gold) !important;
        }
        
        .newsletter-btn:hover {
          background-color: #D4B573 !important;
          transform: translateX(2px);
        }
        
        input::placeholder {
          color: rgba(255, 255, 255, 0.6) !important;
        }
        
        input:focus {
          outline: none;
          border-color: var(--muted-gold) !important;
          background-color: rgba(255, 255, 255, 0.15) !important;
        }
        
        .letter-spacing-1 {
          letter-spacing: 1px;
        }
        
        .extra-small {
          font-size: 0.85rem;
        }
      `}</style>
    </footer>
  );
};

export default Footer;